import React from "react";
import {
  SelectInput,
  TextInput,
  CheckBoxInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { kiosksActions, masterActions } from "../../_store";
import Activeicon from "../../assets/svg/approved.svg";
import Inactiveicon from "../../assets/svg/inactive-user.svg";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch";
import CustomLoader from "../../components/common/ui/Loader";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";

function KIOSKSList() {
  const dispatch = useDispatch();
  const { commonFacilityCode } = useSelector((state) => state.auth);
  const { GetPodList } = useSelector((state) => state.master);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const { podStatusOptions, sharedPodOptions } = useSelector(
    (state) => state.dropdownOptions
  );

  const {
    kiosksList,
    kiosksSearch,
    initialKiosksData,
    shuffleStatus,
    loading,
    kiosksExcelList,
  } = useSelector((state) => state.kiosks);

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  let updatedSearch = { ...kiosksSearch };
  // const [kiosksSearch, setkiosksSearch] = useState({
  //   podID: 0,
  //   kioskCode: "",
  //   maintenanceStatus: 2,
  //   activeStatus: 2,
  //   facilityID: commonFacilityCode,
  //   pageNo: 1,
  //   rowCountPerPage: 10,
  // });

  // Load pod dropdown and facilityDrpdwn
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(masterActions.GetPODList(commonFacilityCode));
  }, [commonFacilityCode]);

  useEffect(() => {
    if (commonFacilityCode) {
      // setkiosksSearch((prev) => ({
      //   ...prev,
      //   facilityID: commonFacilityCode,
      // }));
      dispatch(
        kiosksActions?.setKiosksSearch({
          ...kiosksSearch,
          facilityID: commonFacilityCode,
        })
      );
    }
  }, [commonFacilityCode]);

  //
  useEffect(() => {
    if (commonFacilityCode) {
      const search = { ...kiosksSearch };
      search.facilityID = commonFacilityCode;
      dispatch(kiosksActions?.LoadKioskList(search))
        .then((result) => {
          if (result?.payload?.DataList?.length === 0) {
            const search = { ...kiosksSearch };
            search.facilityID = commonFacilityCode;
            search.pageNo = 1;
            search.rowCountPerPage = 10;
            dispatch(kiosksActions?.setKiosksSearch(search));
            dispatch(kiosksActions?.LoadKioskList(search));
          }
        })
        .catch((err) => { });
    }
  }, [kiosksSearch.facilityID, dispatch, isPageReloading, commonFacilityCode]);

  useEffect(() => {
    switch (shuffleStatus?.IsSucceed) {
      case 1:
        showToastNotification("Updated successfully.", "success");
        dispatch(
          kiosksActions?.LoadKioskList({
            podID: 0,
            kioskCode: "",
            facilityID: commonFacilityCode,
            maintenanceStatus: 2,
            activeStatus: 2,
            pageNo: 1,
            rowCountPerPage: 10,
          })
        );
        dispatch(kiosksActions.clearshuffleStatus());

        break;
      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(kiosksActions.clearshuffleStatus());
        break;

      default:
        break;
    }
  }, [shuffleStatus]);

  useEffect(() => {
    if (kiosksExcelList && kiosksExcelList?.DataList?.length > 0) {
      const title = "Kiosks_List";
      const generateExcelColumns = [
        "Code",
        "Key",
        "POD",
        "Computer",
        "Maintenance",
        "Status",
      ];
      const kioskList = kiosksExcelList?.DataList?.map((obj) => ({
        Code: obj.KiosksCode,
        Key: obj.KiosksMacAddress,
        POD: obj.PodCode,
        Computer: obj.ComputerName,
        Maintenance: obj.Maintenance,
        Status: obj.ActiveStatus === "Yes" ? "Active" : "Inactive",
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(kioskList, generateExcelColumns, title);
        // Clear excel data after the download
        dispatch(kiosksActions.clearkiosksExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [kiosksExcelList]);

  const handleChange = (e, name, isOnblur) => {
    if (
      name === "podID" ||
      name === "maintenanceStatus" ||
      name === "activeStatus"
    ) {
      updatedSearch[name] = name === "podID" ? e?.value ?? 0 : e?.value ?? 2;
      updatedSearch["pageNo"] = 1;
      updatedSearch["rowCountPerPage"] = 10;
      dispatch(kiosksActions?.setKiosksSearch(updatedSearch));

      dispatch(
        kiosksActions?.LoadKioskList({
          ...updatedSearch,
          facilityID: commonFacilityCode,
        })
      );
    } else {
      let value = e?.target?.value;
      dispatch(
        kiosksActions?.setKiosksSearch({
          ...kiosksSearch,
          [e?.target?.name]: isOnblur ? value.trim() : value,
        })
      );
    }
  };

  const handleSubmit = (event) => {
    event?.preventDefault();
    dispatch(
      kiosksActions?.setKiosksSearch({
        ...kiosksSearch,
        facilityID: commonFacilityCode,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
    dispatch(
      kiosksActions?.LoadKioskList({
        ...kiosksSearch,
        facilityID: commonFacilityCode,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
  };

  const handleReset = () => {
    // setkiosksSearch({
    // podID: 0,
    // kioskCode: "",
    // maintenanceStatus: 2,
    // activeStatus: 2,
    // facilityID: commonFacilityCode,
    // pageNo: 1,
    // rowCountPerPage: 10,
    // });
    let data = {
      podID: 0,
      kioskCode: "",
      maintenanceStatus: 2,
      activeStatus: 2,
      facilityID: commonFacilityCode,
      pageNo: 1,
      rowCountPerPage: 10,
    };
    dispatch(
      kiosksActions?.LoadKioskList(
        //   {
        //   podID: 0,
        //   kioskCode: "",
        //   facilityID: commonFacilityCode,
        //   maintenanceStatus: 2,
        //   activeStatus: 2,
        //   pageNo: 1,
        //   rowCountPerPage: 10,
        // }
        data
      )
    );
    dispatch(kiosksActions?.setKiosksSearch(data));
  };

  const handleKiosksClick = async (row) => {
    Swal.close();
    sessionStorage.removeItem("fromPOD");
    let result = GetPodList.filter((data) => {
      return data.value === row?.PodID;
    });
    if (result?.length === 0) {
      showToastNotification("POD Inactivated.", "warning");
      return;
    } else {
      await dispatch(kiosksActions.clearupdateKiosks());
      dispatch(kiosksActions.clearaddKiosks());
      history.navigate("/Admin/KioskList/Add", {
        state: { id: row.KiosksID },
      });
    }
  };

  const columns = [
    {
      key: "KiosksCode",
      name: "Code",
      selector: (row) => row.KiosksCode,
      sortable: true,
      cell: (row) => (
        <div
          onClick={() => handleKiosksClick(row)}
          className="Common_Link_Style d-flex flex-wrap justy-content-left align-items-left"
        >
          {row.KiosksCode}
        </div>
      ),
      center: true,
    },
    {
      name: "Key",
      selector: (row) => row.KiosksMacAddress,
      key: "KiosksMacAddress",
      sortable: true,
    },
    {
      key: "PodCode",
      name: "POD",
      selector: (row) => row.PodCode,
      key: "PodCode",
      sortable: true,
    },
    {
      width: "120px",
      name: "Computer",
      selector: (row) => row.ComputerName,
      key: "ComputerName",
      sortable: true,
    },
    {
      width: "180px",
      name: "Maintenance",
      selector: (row) => row.Maintenance,
      key: "Maintenance",
      sortable: true,
    },
    {
      width: "100px",
      name: "Status",
      selector: (row) => row.ActiveStatus,
      sortable: true,
      key: "ActiveStatus",
      center: true,
      cell: (row) => (
        <div>
          <img
            title={row.ActiveStatus === "Yes" ? "Active" : "Inactive"}
            src={row.ActiveStatus === "Yes" ? Activeicon : Inactiveicon}
            alt={row.ActiveStatus === "Yes" ? "Active" : "Inactive"}
            className="in-icon-size"
          />
        </div>
      ),
    },

    {
      width: "150px",
      key: "IsFacilityKS",
      name: "Shuffle Keyboard",
      selector: (row) => row.IsKS,
      // center: true,
      hide: kiosksList?.DataList?.[0]?.IsFacilityKS === 0 ? true : false,
      cell: (row, index) => (
        <ToggleSwitch
          name={`IsMessageAcess_${row.KiosksID}`}
          id={`IsMessageAcess_${row.KiosksID}`}
          checked={row.IsKS}
          value={row.IsKS}
          handleClick={(e) => handleCheckboxClick(index, e, row)}
        />
      ),
    },
  ];

  const visibleColumns = columns.filter((column) => !column.hide);

  const handleCheckboxClick = (index, e, row) => {
    const { checked } = e?.target;

    const boxData = kiosksList.DataList?.map((item, idx) => {
      return idx === index ? { ...item, IsKS: checked ? 1 : 0 } : item;
    });

    const updateData = {
      kioskID: row.KiosksID,
      facilityID: commonFacilityCode,
      isEnableKeyboardSuffle: boxData[index]["IsKS"],
    };

    dispatch(kiosksActions.UpdateKeyboardShuffleStatus(updateData));
  };

  const RowsCountPerPage = (value) => {
    const datas = { ...kiosksSearch, facilityID: commonFacilityCode };
    datas.rowCountPerPage = value;
    datas.pageNo = 1;
    //setkiosksSearch(datas);
    dispatch(kiosksActions?.setKiosksSearch(datas));
    dispatch(kiosksActions?.LoadKioskList(datas));
  };

  //grid page Onchange
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const data = { ...kiosksSearch, facilityID: commonFacilityCode };
    data.pageNo = value;
    //setkiosksSearch(data);
    dispatch(kiosksActions?.setKiosksSearch(data));
    dispatch(kiosksActions?.LoadKioskList(data));
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...kiosksSearch, facilityID: commonFacilityCode };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(kiosksActions?.setKiosksSearch(search));
    dispatch(kiosksActions.LoadKioskList(search));
  };

  const AddKishoks = () => {
    Swal.close();
    dispatch(kiosksActions.clearKisokInfo());
    if (GetPodList?.length > 0) {
      dispatch(kiosksActions.clearupdateKiosks());
      dispatch(kiosksActions.clearaddKiosks());
      history.navigate("/Admin/KioskList/Add", {
        state: { id: null },
      });
    } else {
      showToastNotification(
        "No more pod exists unassigned for this facility.",
        "warning"
      );
    }
  };

  /// Excel download
  const handleClickExcel = () => {
    const updateTotalRows = {
      ...kiosksSearch,
      RowCountPerPage: kiosksList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
      facilityID: commonFacilityCode,
    };

    dispatch(kiosksActions.LoadKioskList(updateTotalRows));
  };

  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="podID"
                label="POD"
                value={kiosksSearch?.podID}
                handleChange={(e) => handleChange(e, "podID")}
                isClearable={kiosksSearch?.podID !== 0}
                placeholder="Select POD"
                options={GetPodList}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <TextInput
                name="kioskCode"
                id="kioskCode"
                label="Code"
                value={kiosksSearch.kioskCode}
                handleChange={handleChange}
                placeholder="Enter Code"
                required={false}
                handleBlur={(e) => handleChange(e, "kioskCode", true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="maintenanceStatus"
                label="Maintenance"
                value={kiosksSearch.maintenanceStatus}
                handleChange={(e) => handleChange(e, "maintenanceStatus")}
                isClearable={kiosksSearch.maintenanceStatus !== 2}
                placeholder="Select Maintenance"
                options={sharedPodOptions}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-3">
            <div className="form-floating mb-3">
              <SelectInput
                name="activeStatus"
                label="Status"
                value={kiosksSearch.activeStatus}
                handleChange={(e) => handleChange(e, "activeStatus")}
                isClearable={kiosksSearch.activeStatus !== 2}
                placeholder="Select Status"
                options={podStatusOptions}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />
          <Button
            variant="secondary"
            className="me-2"
            onClick={handleReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      {commonFacilityCode > 0 ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            {/* <div className="mb-3">
              <h2 className="form_title_uppercase text-color">KIOSK SEARCH</h2>
            </div> */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  KIOSK SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">KIOSK SEARCH</h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>

          {commonFacilityCode > 0 && (
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
                <h2 className="form_title_uppercase text-color">KIOSKS LIST</h2>
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  <Button
                    variant="success"
                    className="me-2"
                    onClick={AddKishoks}
                    label="Add Kiosk"
                    type="button"
                    status="btn-label"
                    disabled={false}
                    //icon={"fa-solid fa-plus"}
                    imgsrc={AddIcon}
                  />
                  {kiosksList?.DataList?.length > 0 && (
                    <ExcelExport handleExcelExport={handleClickExcel} />
                  )}
                </div>
              </div>

              <Table
                columns={visibleColumns}
                data={kiosksList?.DataList}
                totalRowCount={kiosksList?.TotalRecordCount}
                currentPage={kiosksSearch?.pageNo}
                pagination={true}
                paginationPerPage={kiosksSearch?.rowCountPerPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={RowsCountPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={kiosksSearch.sortBy?.split(" ")[0]}
                sortDirection={kiosksSearch?.sortBy?.split(" ")[1]}
              />
            </div>
          )}
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
}

export default React.memo(KIOSKSList);
